var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05597 0.423853C7.64308 -0.141284 8.59355 -0.141284 9.17916 0.423853L21.5954 12.4055C22.7682 13.5372 22.7682 15.3731 21.5954 16.5048L9.08906 28.5757C8.50797 29.135 7.56953 29.1426 6.98093 28.5905C6.37881 28.0269 6.37281 27.0976 6.96442 26.5253L18.4106 15.4803C18.9978 14.9138 18.9978 13.9965 18.4106 13.43L7.05597 2.47283C6.46887 1.90769 6.46887 0.990426 7.05597 0.423853Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.ae6a7f9ad15d12dc1ac067fefbda1c2b.svg";
export { ForwardRef as ReactComponent };